import * as types from "../../../_constants/types";

export default (state = null, action) => {
    switch (action.type) {
        case types.COUNTRY_LOAD:
            return action.results;

        case types.RESET:
        case types.COUNTRY_RESET:
            return null;

        default:
            return state;
    }
};
